import { CHANNEL_ID, CUSTOMER_ID, featureToggle } from '../constants/common';
import TagManager from 'react-gtm-module';
import login from './modules/login';
import mflp from './modules/mflp';
import kyc from './modules/kyc';
import redeem from './modules/redeem';
import statements from './modules/statements';
import portfolio from './modules/potfolio';
import banner from './modules/banner';
import explore from './modules/explore';
import planGoalsSip from './modules/planGoalsSip';
import error from './modules/error';
import registration from './modules/registration';
import investmentIdeas from './modules/investmentIdeas';
import switchOrSTP from './modules/switch';
import transaction from './modules/transaction';
import investBasisRiskProfile from './modules/investBasisRiskProfile';
import investMore from './modules/investMore';
import saveTax from './modules/saveTax';
import mobileNavigation from './modules/mobileNavigation';
import transactInvest from './modules/transactInvest';
import { getCookie } from './utils';
import { encryptString } from '../utils/encrypt';
import { insights } from './modules/insights';
import faq from './modules/faq';
import nfo from './modules/nfo';

interface GtmData {
  event?: string;
  page?: string;
  title?: string;
  category?: string;
  action?: string;
  label?: string;
}

export interface GtmCustomData {
  cd2?: string; // <<pass the encrypted user id>>,
  cd24?: string; // <<pass platform either website or internet-banking or mobile-app>>,
  cd64?: string; // <<error_code>>
  cd66?: string; // <<type_of_fund>>,
  cd67?: string; //  <<duration_of_funds>>,
  cd68?: string; //  <<pass either growth or dividend>>,
  cd69?: string; //  <<nature_of_mf_payment>>,
  cd70?: string; //  <<lumpsum_allocation pass either amount or units>>,
  cd71?: string; //  <<pfm_reference_number>>,
  cd72?: string; //  <<risk_profiler>>
  cd73?: string; //  <<sip_goal>>
  cd74?: string; // <<investment_id>>
  cd75?: string; // Pass either full or partial switch | redemption
}

interface GtmDataLayer extends GtmData, GtmCustomData {}

const GTM_ID = 'GTM-TFJQKFG';

let gtmData: GtmCustomData = {};

const GTM = {
  initialise: () => {
    TagManager.initialize({ gtmId: GTM_ID });
  },
  login: login(),
  mflp: mflp(),
  mobileNavigation: mobileNavigation(),
  kyc: kyc(),
  redeem: redeem(),
  statements: statements(),
  portfolio: portfolio(),
  transactInvest: transactInvest(),
  banner: banner(),
  transaction: transaction(),
  registration: registration(),
  error: error(),
  investmentIdeas: investmentIdeas(),
  switch: switchOrSTP(),
  explore: explore(),
  planGoalsSip: planGoalsSip(),
  investBasisRiskProfile: investBasisRiskProfile(),
  investMore: investMore(),
  saveTax: saveTax(),
  insights: insights(),
  faq: faq(),
  nfo: nfo(),
};

//below Function adds cd2 and cd24 values to the recordEvent GTM dataLayer object
export const recordEventWrapper = (datalayer) => {
  recordEvent({...datalayer, cd2: encryptString(getCookie(CUSTOMER_ID)), cd24: getCookie(CHANNEL_ID)})
}
export const recordEvent = (dataLayer: GtmDataLayer) => {
  if (!featureToggle.GA) return;
  TagManager.dataLayer({
    dataLayer,
  });
};

export const getGtmData = (gtmDataKey: keyof GtmCustomData) => {
  return gtmData[gtmDataKey] || null;
};

export const setGtmData = (gtmDataKey: keyof GtmCustomData, gtmDataValue: string) => {
  gtmData = { ...gtmData, [gtmDataKey]: gtmDataValue };
};

export default GTM;
